// extracted by mini-css-extract-plugin
module.exports = {"item":"BottomSheetContentsSelectIcon_item__2NgXt","icon":"BottomSheetContentsSelectIcon_icon__2wMHM","label":"BottomSheetContentsSelectIcon_label__1BhLK"};